import React from 'react'
import {loadCategories, setCategories, setCategoryName} from '../../store/category'
import {connect} from 'react-redux'
import {IndexLink} from 'react-router'

class Categories extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            categories: this.props.categories,
        }

        this.props.loadCategories()
        this.setCategories = this.props.setCategories
    }

    componentWillReceiveProps(nextProps) {
        this.setState({categories: nextProps.categories})
    }

    handleClick = (id) => {
        this.setCategories(this.state.categories, id)
        this.props.setCategoryName(this.state.categories, id)
    }

    render() {
        const listItems = this.state.categories.map((element, index) => {
            if(element.count === 0) return;
            return (                
                <div key={index}>
                    <div onClick={() => this.handleClick(element.id)}>
            <span className={element.active ? 'active-menu-item cat-link-arrow' : 'cat-link-arrow'}>
              {element.items.length ?
                  <span>{element.name} <span className="count-of-category">({element.count})</span></span>
                  :
                  <IndexLink to={'/deals/?' + element.url}>
                      {element.name} <span className="count-of-category">({element.count})</span>
                  </IndexLink>
              }
              </span>
                        <span className={'cat-link-arrow'}
                              style={element.items.length ? {visibility: 'visible'} : {visibility: 'hidden'}}>
                    {element.opened ? <span className={'cat-link-arrow'}>&#9650;</span> :
                        <span className={'cat-link-arrow'}>&#9660;</span>}
                </span>
                    </div>
                    <div style={element.opened ? {display: 'block'} : {display: 'none'}}>
                        <ul className="sidebar-sub-menu">
                            {element.items.map((i, inx) => {
                                if (i.count === 0) return null
                                return (
                                    <div key={inx} className={i.active ? 'active-menu-item' : ''}>
                                        <IndexLink to={'/deals/?' + i.url}
                                                   onClick={() => this.handleClick(i.id)}>
                                            {i.name} <span className="count-of-category">({i.count})</span>
                                        </IndexLink>
                                    </div>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            )
        })

        return (
            <div>
                <h5 className="sidebar-menu-title">CATEGORIES</h5>
                <ul className="sidebar-menu">
                    {listItems}
                </ul>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        categories: state.categories,
        search: state.search,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCategories: () => dispatch(loadCategories()),
        setCategories: (categories, cid) => dispatch(setCategories(categories, cid)),
        setCategoryName: (categories, cid) => dispatch(setCategoryName(categories, cid))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Categories)



// WEBPACK FOOTER //
// ./src/components/categories/Categories.js